import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import "./videoModal.css";
import "../watch/watch.css";
import JWPlayer from "@jwplayer/jwplayer-react";
import Global from "../../global";
import { addForwardButton } from "../javascript/function";
import { useRef, useState } from "react";

const VideoModal = (props) => {
  const [mounted, setMounted] = useState(false);
  const playerRef = useRef({});

  const onReady = (event) => {
    if (mounted) {
      addForwardButton(playerRef.current);
    }
  };
  const playerMountedCallback = ({ player }) => {
    playerRef.current = player;
    setMounted(true);
  };
  const playerUnmountingCallback = ({ player }) => {
    playerRef.current = null;
    setMounted(false);
  };

  return (
    <div>
      <Modal
        open={props.open}
        onClose={props.onCloseModal}
        center
        classNames={{
          modal: "videoModal",
          overlay: "videoOverlay",
        }}
      >
        <div className="watchClass">
          <JWPlayer
            library={
              Global.SDP
                ? "https://cdn.jwplayer.com/libraries/" + Global.SDP + ".js"
                : "https://cdn.jwplayer.com/libraries/" + Global.FSP + ".js"
            }
            playlist={"https://cdn.jwplayer.com/v2/media/" + props.trailer}
            didMountCallback={playerMountedCallback}
            playerUnmountingCallback={playerUnmountingCallback}
            onReady={onReady}
          ></JWPlayer>
        </div>
      </Modal>
    </div>
  );
};

export default VideoModal;
